import { Box, Divider, Stack, Typography } from '@mui/material';
import { MobileCardHeaderItem } from '../organisms/StyledMobileDataGrid/types';

import { mergeSx } from '../../utils/styles';

const styles = {
  container: {
    width: '100%',
    minWidth: 0,
  },
  itemBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    minWidth: 0,
  },
  itemStack: {
    minWidth: 0,
    width: '100%',
  },
  text: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '100%',
  },
  divider: {
    height: 24,
    alignSelf: 'center',
  },
};

type MobileCardHeaderProps = {
  items: MobileCardHeaderItem[];
};

export const MobileCardHeader = ({ items }: MobileCardHeaderProps) => {
  return (
    <Stack
      direction='row'
      spacing={1.5}
      sx={mergeSx(
        {
          alignItems: 'center',
        },
        styles.container
      )}
    >
      {items.map((item, index) => (
        <Box key={`${item.label}-${index}`} sx={{ ...styles.itemBox, flex: item.flex }}>
          <Stack spacing={0.5} sx={styles.itemStack}>
            {item.label && (
              <Typography
                variant='body3'
                component='span'
                noWrap
                sx={mergeSx(
                  {
                    color: 'text.secondary',
                    textAlign: item.align ?? 'center',
                  },
                  styles.text
                )}
              >
                {item.label}
              </Typography>
            )}
            <Typography
              variant={item.variant ?? 'body3'}
              component='span'
              noWrap
              color={item.color}
              sx={mergeSx(
                {
                  fontWeight: item.fontWeight ?? 500,
                  textAlign: item.align ?? 'center',
                },
                styles.text
              )}
            >
              {item.value}
            </Typography>
          </Stack>
          {index < items.length - 1 && <Divider orientation='vertical' flexItem sx={styles.divider} />}
        </Box>
      ))}
    </Stack>
  );
};
